<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-1-column--centered">
      <section
        class="grid-container-1-column__item"
        style="justify-self: auto; width: 100%; max-width: 525px;"
        v-if="this.userAuthorisedB2B || this.userAuthorisedB2C"
      >
        <q-card flat class="cta-card">
          <q-card-section class="cta-card__section">
            <span class="cta-card__label"
              >Check out the list of suppliers we are already live with:</span
            >
            <div class="cta-card__buttons q-gutter-sm">
              <q-btn
                v-if="this.userAuthorisedB2B"
                outline
                color="secondary"
                @click="
                  openDialog(
                    'https://sharing.clickup.com/gr/h/69xwy-6088/c48bdf7ebe579d7',
                    '<span>Suppliers</span>'
                  )
                "
                label="Suppliers"
                no-caps
              />
              <q-btn
                v-if="this.userAuthorisedB2C"
                outline
                color="secondary"
                @click="
                  openDialog(
                    'https://sharing.clickup.com/gr/h/69xwy-6068/a38193f1ef3b445',
                    '<span>Suppliers</span>'
                  )
                "
                label="Suppliers"
                no-caps
              />
            </div> </q-card-section
        ></q-card>
      </section>
      <div class="grid-container-1-column--centered">
        <section class="grid-container-1-column__item">
          <q-card flat class="form-card" style="width:100%; max-width: 525px">
            <q-card-section class="form-card__section">
              <NewRequest formType="New_Request" /> </q-card-section
          ></q-card>
        </section>
      </div>
    </div>
    <IframeDialog :open.sync="alert" :url="url" :title="title" />
  </q-page>
</template>

<script>
import IframeDialog from "@/components/dialog/Iframe.vue";
import NewRequest from "@/components/forms/NewRequest.vue";
export default {
  name: "SupplierAndGameRequests",
  data() {
    return {
      alert: false,
      url: null,
      userAuthorisedB2B: false,
      userAuthorisedB2C: false,
      title: null,
    };
  },
  components: {
    IframeDialog,
    NewRequest,
  },
  methods: {
    checkUserRolePermissions() {
      const userRoles = this.$store.getters.GET_CURRENT_USER_ROLE_FUNCTIONS;
      if (userRoles.includes(52 && 53)) {
        // B2C users
        this.userAuthorisedB2C = true;
        this.userAuthorisedB2B = true;
      } else if (userRoles.includes(53)) {
        // B2C users
        this.userAuthorisedB2C = true;
      } else if (userRoles.includes(52)) {
        // B2B users
        this.userAuthorisedB2B = true;
      } else {
        this.url = null;
        this.userAuthorisedB2C = false;
        this.userAuthorisedB2B = false;
      }
    },
    openDialog(url, title) {
      this.alert = true;
      this.url = url;
      this.title = title;
    },
  },
  mounted() {
    this.checkUserRolePermissions();
  },
};
</script>
